function Loader() {
  return (
    <div className="app loader">
      <div className="box correct no-border reveal-infinite">W</div>
      <div className="box wrong no-border reveal-infinite">O</div>
      <div className="box wrong no-border reveal-infinite">R</div>
      <div className="box present no-border reveal-infinite">D</div>
      <div className="box reveal-infinite">L</div>
      <div className="box present no-border reveal-infinite">E</div>
    </div>
  );
}

export default Loader;
